// extracted by mini-css-extract-plugin
module.exports = {"cta":"cta-module--cta--25gWS","box":"cta-module--box--2qe9G"};